import {Component} from '@angular/core';
import {map, timer} from 'rxjs';

import {ClientSettingsComponent} from '../client-settings.component';
import {ClientService} from '../../../services/auth/client.service';
import {ClientProductionConfigSyncService} from '../../../services/objects/client-production-config-sync.service';
import {ToastService} from '../../../services/layout/toast.service';
import {IClientOptions} from '../../../models/client-options.model';
import {IClientProductionConfigSyncResult} from '../../../models/client-production-config-sync.model';
import {ClientPreparationService} from '../../../services/objects/client-preparation.service';

@Component({
  selector: 'app-client-settings-visual-fixture',
  standalone: true,
  imports: [ClientSettingsComponent],
  template: `
    <main class="client-settings-visual-fixture">
      <app-client-settings [client]="client"></app-client-settings>
    </main>
  `,
  styles: [`
    .client-settings-visual-fixture {
      display: block;
      padding: 24px;
      background: #f5f7fb;
      min-height: 100vh;
    }
  `],
  providers: [
    {provide: ClientPreparationService, useValue: {available: false}},
    {
      provide: ClientService,
      useValue: {
        client: createFixtureClient(),
        clients: [createFixtureClient()]
      }
    },
    {
      provide: ClientProductionConfigSyncService,
      useValue: {
        preview: () => timer(700).pipe(map(() => ({
          clientId: 'fixture-client', revision: 'fixture-revision', overwriteCount: 1,
          changes: [{container: 'shop-assistants', id: 'fixture-bot', name: 'My local chatbot', action: 'replace'}]
        }))),
        // Delayed synthetic response exercises progress without importing customer data.
        syncFromProduction: () => timer(4000).pipe(map((): IClientProductionConfigSyncResult => ({
          configurationImported: true,
          productFeedsRequiringIndex: [],
          clientId: 'fixture-client',
          sourceDatabaseId: 'fixture-source',
          targetEnvironment: 'local',
          excludedContainers: ['master-threads'],
          preservedFields: ['functions.BearerKey'],
          containers: [{container: 'fixture-settings', upserted: 12, preservedSecrets: 2, skipped: false}]
        })))
      }
    },
    {
      provide: ToastService,
      useValue: {
        showSuccess: () => undefined,
        showError: () => undefined,
        showInfo: () => undefined
      }
    }
  ]
})
export class ClientSettingsVisualFixtureComponent {
  readonly client = createFixtureClient();
}

function createFixtureClient(): IClientOptions {
  return {
    id: 'fixture-client',
    name: 'Fixture Client',
    description: 'Local visual fixture client.',
    domain: 'fixture.example.com',
    logo: '/assets/images/logos/shine.svg',
    enabledProducts: ['Shine AI']
  } as IClientOptions;
}
